import {
  AffectiveType,
  OptionType,
} from 'apps/web/enums/iPlanObjectives/categories.enum';
import {
  Domain,
  OptionLayer,
  ValueOptions,
} from 'apps/web/types/labelled-collection.type';

import { createValueCategoryLabels, getValuesByCategory } from './affective';
import { LIST_OF_ATTITUDES } from './affective/additional-options';
import {
  createCognitiveDomain,
  createAffectiveDomain,
  createPsychomotorDomain,
} from './utils/domainBuilder';

const createOptionLayers = (
  domainCreator: (type: OptionType) => Domain[],
): OptionLayer[] => [
  { label: OptionType.Digital, items: domainCreator(OptionType.Digital) },
  { label: OptionType.Standard, items: domainCreator(OptionType.Standard) },
];

export const COGNITIVE_BEHAVIORAL_VERBS: OptionLayer[] = createOptionLayers(
  createCognitiveDomain,
);
export const AFFECTIVE_BEHAVIORAL_VERBS: OptionLayer[] = createOptionLayers(
  createAffectiveDomain,
);
export const PSYCHOMOTOR_BEHAVIORAL_VERBS: OptionLayer[] = createOptionLayers(
  createPsychomotorDomain,
);

export const AFFECTIVE_VALUES: ValueOptions[] = createValueCategoryLabels().map(
  (label, index) => ({
    label,
    items: getValuesByCategory()[index] || [],
  }),
);

export const AFFECTIVE_SECTIONS_CONFIG = {
  [AffectiveType.VALUES]: {
    itemOptions: AFFECTIVE_VALUES,
    pairLabel: 'Value',
    sectionLabel: 'Affective - Values',
    baseItemKey: 'valuesList',
    baseVerbKey: 'affectiveValuesVerbs',
    buttonText: 'Add Another Affective Value',
  },
  [AffectiveType.ATTITUDES]: {
    itemOptions: LIST_OF_ATTITUDES,
    pairLabel: 'Attitude',
    sectionLabel: 'Affective - Attitudes',
    baseItemKey: 'attitudesList',
    baseVerbKey: 'affectiveAttitudesVerbs',
    buttonText: 'Add Another Affective Attitude',
  },
};
